"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var __1 = __importDefault(require(".."));

require("./style.scss");
/**
 * General `Icon` used for Image rendering.
 */


var ImageIcon = function ImageIcon(_a) {
  var name = _a.name,
      url = _a.url;
  return react_1.default.createElement(__1.default, {
    name: name,
    source: "img"
  }, react_1.default.createElement("img", {
    src: url,
    alt: name
  }));
};

ImageIcon.propTypes = {
  /** Name of the `Icon` */
  name: prop_types_1.default.string,

  /** Reference source of the image file. */
  url: prop_types_1.default.string.isRequired
};
ImageIcon.defaultProps = {
  name: 'image icon'
};
exports.default = ImageIcon;